const registerDWHToWindow = (): void => {
    window.sazka = window.sazka || {};
    window.sazka.dwh = window.sazka.dwh || {};
};

const isDWHRegistered = (): boolean => {
    return window.sazka.dwh !== undefined;
};

const expose = (name: string, method: (...args: any[]) => any) => {
    if (!isDWHRegistered()) {
        registerDWHToWindow();
    }

    window.sazka.dwh[name] = method;
};

export const useDWH = () => ({
    expose,
});
